/**
 * 令牌存储。单独抽一层是为了避免 axios 拦截器和 Pinia store 互相 import 造成循环依赖 ——
 * 拦截器只依赖这里，store 也只依赖这里。
 */
const ACCESS_KEY = 'dsv.accessToken';
const REFRESH_KEY = 'dsv.refreshToken';
const TEST_KEY = 'dsv.testViewToken';

export const tokenStorage = {
  getAccess(): string | null {
    return sessionStorage.getItem(TEST_KEY) ?? localStorage.getItem(ACCESS_KEY);
  },
  getRefresh(): string | null {
    return sessionStorage.getItem(TEST_KEY) ? null : localStorage.getItem(REFRESH_KEY);
  },
  set(accessToken: string, refreshToken: string): void {
    localStorage.setItem(ACCESS_KEY, accessToken);
    localStorage.setItem(REFRESH_KEY, refreshToken);
  },
  clear(): void {
    if (sessionStorage.getItem('dsv.returnToAdmin')) return;
    // 测试令牌失效只退出本标签页测试，不删除管理员会话。
    if (sessionStorage.getItem(TEST_KEY)) {
      sessionStorage.removeItem(TEST_KEY);
      sessionStorage.setItem('dsv.returnToAdmin', 'true');
      sessionStorage.setItem('dsv.testViewEnded', 'true');
      return;
    }
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
  adminAccess: () => localStorage.getItem(ACCESS_KEY),
  adminRefresh: () => localStorage.getItem(REFRESH_KEY),
  enterTestView: (token: string) => sessionStorage.setItem(TEST_KEY, token),
  exitTestView: () => sessionStorage.removeItem(TEST_KEY),
};
